/* global angular */

export default function TrainingController(
  $q,
  $routeParams,
  loaderService,
  eduDataService
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.loaderService = loaderService;
  vm.sectionIsHovered = false;
  vm.selectedTopicId = $routeParams.topicId || -1;
  vm.filterText = '';
  vm.documentsVisible = true;
  vm.videosVisible = true;
  vm.presentationsVisible = false;
  vm.isAllTopicExpanded = true;
  vm.handleTopicFilterClick = _handleTopicFilterClick;
  vm.handleSectionFilterClick = _handleSectionFilterClick;
  vm.handleFilterInputChange = _handleFilterInputChange;
  vm.handleFilterCheckboxChange = _handleFilterCheckboxChange;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    _refreshPageData().then(dfdActivate.resolve);

    dfdActivate.promise.then(() => {
      vm.appIsLoaded = true;
    });
  }

  // //// Initialize Module //////

  // Common
  function _refreshPageData() {
    const dfdRefreshPage = $q.defer();
    eduDataService.getTopics().then((topicsData) => {
      vm.topics = topicsData.data.result;
      _filterMedia().then(() => {
        dfdRefreshPage.resolve();
      });
    });
    return dfdRefreshPage.promise;
  }

  // //// Filtering //////

  // Topics
  function _handleTopicFilterClick(topicId) {
    vm.selectedSectionId = null;
    _setTopicFilterByID(topicId);
    _filterMedia();
  }

  function _setTopicFilterByID(topicId) {
    vm.selectedTopicId = topicId;
  }

  // Sections
  function _handleSectionFilterClick($event, topicId, sectionId) {
    $event.stopPropagation();
    _setSectionFilterByID(topicId, sectionId);
    _filterMedia();
  }

  function _setSectionFilterByID(topicId, sectionId) {
    _setTopicFilterByID(topicId);
    vm.selectedSectionId = sectionId;
  }

  // Search
  function _handleFilterInputChange(newText) {
    vm.filterText = newText;
    _filterMedia();
  }

  function _handleFilterCheckboxChange() {
    _filterMedia();
  }

  function _checkTextMatchesFilter(text) {
    return vm.filterText === ''
      ? true
      : text === null
        ? false
        : text.toLowerCase().indexOf(vm.filterText.toLowerCase()) > -1;
  }

  function _filterMedia() {
    const dfdFilter = $q.defer();
    vm.noMedia = true;
    angular.forEach(vm.topics, (topic, topicIndex) => {
      let isLastTopic = false;
      if ((topicIndex === vm.topics.length - 1) || (vm.topics.length === 0)) {
        isLastTopic = true;
      }
      topic.isVisible = false;
      topic.nameMatchesFilter = _checkTextMatchesFilter(topic.name);
      topic.descriptionMatchesFilter = _checkTextMatchesFilter(topic.description);
      topic.topicSelected = vm.selectedTopicId === -1
        || vm.selectedTopicId === topic.topicId;

      angular.forEach(topic.sections, (section, sectionIndex) => {
        let isLastSection = false;
        if ((sectionIndex === topic.sections.length - 1)) {
          isLastSection = true;
        }
        section.isVisible = false;
        section.nameMatchesFilter = _checkTextMatchesFilter(section.name);
        section.sectionSelected = !vm.selectedSectionId
          || vm.selectedSectionId === null
          || vm.selectedSectionId === section.sectionId
          || (vm.selectedSectionId === null && vm.selectedTopicId === topic.topicId);

        if (section.medias.length > 0) {
          angular.forEach(section.medias, (media, mediaIndex) => {
            let isLastMedia = false;
            if ((mediaIndex === section.medias.length - 1) || (section.medias.length === 0)) {
              isLastMedia = true;
            }
            media.isVisible = false;
            media.nameMatchesFilter = _checkTextMatchesFilter(media.name);
            media.descriptionMatchesFilter = _checkTextMatchesFilter(media.description);
            media.keywordsMatchFilter = _checkTextMatchesFilter(media.keywords);
            if (
              topic.nameMatchesFilter
              || topic.descriptionMatchesFilter
              || section.nameMatchesFilter
              || media.nameMatchesFilter
              || media.descriptionMatchesFilter
              || media.keywordsMatchFilter
            ) {
              if (
                topic.topicSelected
                && section.sectionSelected
                && (
                  (
                    media.mediaTypeId === 1
                    && vm.documentsVisible
                  ) || (
                    media.mediaTypeId === 2
                    && vm.videosVisible
                  ) || (
                    media.mediaTypeId === 3
                    && vm.presentationsVisible
                  ) || (
                    media.mediaTypeId === 4
                    && vm.videosVisible
                  )
                )
              ) {
                topic.isVisible = true;
                section.isVisible = true;
                media.isVisible = true;
                vm.noMedia = false;
              }
            }
            if (isLastTopic && isLastSection && isLastMedia) {
              dfdFilter.resolve();
            }
          });
        } else if (isLastTopic && isLastSection) {
          dfdFilter.resolve();
        }
      });
    });
    return dfdFilter.promise;
  }
}

TrainingController.$inject = [
  '$q',
  '$routeParams',
  'loaderService',
  'eduDataService'
];
